import { defineStore } from 'pinia'

import { useAuthStore } from '@/stores/Auth'
import _menu from '@/view/Layouts/DashContainer/_menu'

export const useSidebarStore = defineStore('sidebarStore', {
  state: () => ({
    isOpen: false,
    sidePanel: '',
    onlyIcons: false,
  }),
  actions: {
    openBar() {
      this.isOpen = true
    },
    closeBar() {
      this.isOpen = false
    },
    toggleBar() {
      this.isOpen = !this.isOpen
    },
    setSidePanel(panel) {
      this.sidePanel = panel
    },
    toggleOnlyIcons() {
      this.onlyIcons = !this.onlyIcons
    },
  },
  getters: {
    isSideBarOpen: state => state.isOpen,
    getSideBar() {
      const authStore = useAuthStore()
      return authStore.isSuperuser ? [..._menu.admin, ..._menu.shared] : [..._menu.shared]
    },
  },
})
